
import {interval as observableInterval, Observable, Subscription} from 'rxjs';
import { EstadoProgresosService } from '../../_services/_index';

export class Progress{
    id:number;
    private progreso:number;
    private service:EstadoProgresosService;
    private subscription: Subscription;
    constructor(id:number,estadoProgresosService:EstadoProgresosService){
        this.id = id;
        this.service = estadoProgresosService;
        this.progreso = 0;
    }
    
    public getProgreso():number{
        return this.progreso;
    }
    public setProgreso(p:number){
        this.progreso = p;
    }
    public start(){
        this.progreso = 0;
        this.subscription = observableInterval(1000).subscribe(x => {
            this.service.getEstadoProgreso(1).subscribe(p => {
                this.progreso = p.Data;
                if(this.progreso == 100){
                    this.stop();
                }
            });
        });
    }
    public stop(){
        if (this.subscription != null && !this.subscription.closed) {
            this.subscription.unsubscribe();
        }

    }
    public isRunning(){
        return this.subscription && !this.subscription.closed;
    }

    setStyles() {
        let styles = {
            // CSS property names
            'width': this.progreso + '%',  // normal
        };
        return styles;
    }


}